export const isValidUrl = (url) => {
    try {
        if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
            return new URL(url)
        }
        else{
            return new URL(url, window.location.protocol + window.location.hostname)
        }
    } catch (e) {
      console.error(e)
      return false
    }
    // return true
  }

export const imgUrlConverter = (iUrl) => {
    if (iUrl) {
        const url = isValidUrl(iUrl)
        if (url) {
            if(window.domainVariables){
                let {imageDomain} = window.domainVariables
                return imageDomain + url.pathname + url.search + url.hash
            }
            let host = url.hostname
            switch (window.location.hostname) {
                case 'localhost':
                case 'devwww.jostens.com':
                case 'dev1cms.jostens.com':
                case 'dev-jostens.dotcmscloud.com':
                case 'dev1cms-prochamp.jostens.com':
                case 'devwww.prochamp.jostens.com':
                    host = 'devwww.jostens.com'
                    break
                
                case 'testwww.jostens.com':
                case 'test-jostens.dotcmscloud.com':
                case 'testwww.prochamp.jostens.com':
                    host = 'testwww.jostens.com'
                    break
            
                case 'demowww.jostens.com':
                case 'demo-jostens.dotcmscloud.com':
                case 'demowww.prochamp.jostens.com':
                    host = 'democdn.jostens.com'
                    break
            
                case 'qawww.jostens.com':
                case 'qa-jostens.dotcmscloud.com':
                case 'qawww.prochamp.jostens.com':
                    host = 'qacdn.jostens.com'
                    break
    
                case 'www.jostens.com':
                case 'www.prochamp.jostens.com':
                    host = 'cdn.jostens.com'
                    break
    
                default:
                    break;
            }
            return url.protocol + '//' + host + url.pathname + url.search + url.hash
        } else {
            return iUrl
        }
    }
    return null
}

export const alternateUrlConverter = (aUrl) => {
    if (isValidUrl(aUrl)) { 
        return aUrl
    } else {
        return 'https://www.jostens.com' + aUrl
    }
}

export const actionUrlConverter = (aUrl) => {
    let host
    if (window.location.hostname === 'dev1cms.jostens.com' || window.location.hostname === 'localhost' || window.location.hostname === 'dev-jostens.dotcmscloud.com' 
        || window.location.hostname === 'devwww.prochamp.jostens.com') {
        host = 'devwww.prochamp.jostens.com'
    } else if (window.location.hostname === 'uatcms.jostens.com') {
        host = 'demowww.prochamp.jostens.com'
    }else if (window.location.hostname === 'authcms.jostens.com') {
        host = 'www.prochamp.jostens.com'
    } else {
        host = window.location.hostname
    }

    const url = isValidUrl(aUrl)
    if (url) {
        return window.location.protocol + '//' + host + url.pathname + url.search + url.hash
    } else {
        return window.location.protocol + '//' + host + aUrl
    }
}

export const hostUrlConverter = (aUrl) => {
    let host
    if (window.location.hostname === 'dev1cms.jostens.com' || window.location.hostname === 'localhost' || window.location.hostname === 'dev-jostens.dotcmscloud.com' 
        || window.location.hostname === 'devwww.prochamp.jostens.com') {
        host = 'devwww.jostens.com'
    } else if (window.location.hostname === 'uatcms.jostens.com' || window.location.hostname === 'demowww.prochamp.jostens.com') {
        host = 'demowww.jostens.com'
    } else if (window.location.hostname === 'qawww.prochamp.jostens.com') {
        host = 'qawww.jostens.com'
    } else if (window.location.hostname === 'authcms.jostens.com' || window.location.hostname === 'www.prochamp.jostens.com') {
        host = 'www.jostens.com'
    } else {
        host = window.location.hostname
    }

    const url = isValidUrl(aUrl)
    if (url) {
        return window.location.protocol + '//' + host + url.pathname + url.search + url.hash
    } else {
        return window.location.protocol + '//' + host + aUrl
    }
}

export const heroBannerEvent = (events) => {
    return events.filter( e => {
                const dateRange = e.dateRange.split(' - ')
                const endDay = new Date(dateRange[1])
                const today = new Date();
                const days = Math.ceil((endDay.getTime() - today.getTime()) / (1000 * 3600 * 24))
                return days >= 0 && days <= 14 && e.runningTopEvent === true && e.schedulingUrl
            })[0]
}

export const daysBetweenToday = (d) => {
    const today = new Date();
    return Math.ceil((d.getTime() - today.getTime()) / (1000 * 3600 * 24))
}